import React from "react";
import { Modal, ModalProps } from "antd";
import SVGIcon from "../../utils/SVGIcon";
import Config from "../../config/Config";

/**
 * Renders a common modal component for log out and delete a record.
 *
 * @param {ModalProps} rest - The props for the modal component.
 * @return {ReactElement} The rendered modal component.
 */
const CommonModal: React.FC<ModalProps> = ({ ...rest }) => {
  return (
    <Modal
      centered
      className="create_modal"
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
      footer={null}
      {...rest}
    />
  );
};

export default CommonModal;
